import { BankPositionsFormCard } from "./edit_card";

export function BankPositionsNew() {
  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <BankPositionsFormCard />
      </div>
    </div>
  );
}
